import React from 'react'
import tankImage from "../../../images/products/H.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/about/tank-banner.jpg'

function Tank3() {

   const values = [
    {
      number: 1,
      text: "Long lasting – Built with durable materials to ensure years of reliable use.",
    },
    {
      number: 2,
      text: "Leakproof – Designed to prevent any water leakage for complete peace of mind.",
    },
    {
      number: 3,
      text: "Lightweight – Easy to transport and install without heavy equipment.",
    },
    {
      number: 4,
      text: "Easy to install – User-friendly design that supports quick and hassle-free setup.",
    },
    {
      number: 5,
      text: "6 layers – Multiple protective layers for extra strength and temperature control.",
    },
    {
      number: 6,
      text: "Affordable – Quality you can trust at a price that fits your budget.",
    },
      {
      number: 7,
      text: "Available in various colors – Choose from a range of colors to suit your space.",
    },
      {
      number: 8,
      text: "Resistant to bacterial growth – Maintains water hygiene with anti-bacterial inner layer.",
    },
  ];

  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'3 Layer Water Tank'} pagesub={'Water Tank'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
          <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
          <h2 className="fw-bold mb-3">Strong Tanks. Simple Solutions.</h2>
        <p style={{textAlign:"justify"}}>
         In many areas, people still rely on borewells, tanker supply, or limited water timings—making dependable water storage a daily necessity. Whether it's for homes, farms, or industries, storing clean water properly saves both time and effort.
       </p>
       <p style={{textAlign:"justify"}}>
        At SNBS, we offer durable 3-layer water tanks made from 100% virgin, food-grade plastic. These tanks are leakproof, UV-resistant, long-lasting, and designed to perform well even in open spaces and under harsh sunlight. The three layers help maintain water quality, protect against heat, and ensure safe storage.
      </p>
      <p style={{textAlign:"justify"}}>
        Our tanks come in sizes like 3000L, 5000L, 7500L, and 10000L. They are easy to install, affordable, and resistant to bacterial growth—making them a reliable choice for households, farms, and businesses.
      </p>
        </div>
      </div>
    </section>
 <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">3 Layer Water Tank</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                Water tanks available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                3 Layer Water Tank Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default Tank3